/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".block-iframe[_ngcontent-%COMP%]{border:0;border-radius:2rem;width:100%;margin:2rem 0}.sidebar-wrapper[_ngcontent-%COMP%]{height:calc(100% - 60px);overflow:auto}"];
export { styles as styles };
